import VideoCard from './VideoCard.vue';
import {ref, reactive, toRefs, computed, defineComponent,onBeforeMount, onMounted, getCurrentInstance, watch, provide,nextTick} from 'vue';
import VideoListUtil,{IVideoListDataObj} from './videoListUtil';
export default defineComponent ({
    name: 'VideoList',
    setup(){
        const {proxy}=getCurrentInstance() as any;
        const utils=proxy.utils;
        let dataObj:IVideoListDataObj=reactive<IVideoListDataObj>({
            pageListRef:null,
            utilInst:{} as any,
            refMap:new Map(),
            pageList: {
                queryParam: {},
                modelComp: VideoCard,
                modelMethod: utils.ToolsProviderApi.buildUrl('/video/pageData')
            },
            otherParams:{
                videoTypeData:[]
            },
        })
        onBeforeMount(()=>{
            dataObj.utilInst=new VideoListUtil(proxy,dataObj);
        })
        onMounted(()=>{
            nextTick(async()=>{
                await dataObj.utilInst.buildSelectData();
            })
        })
        //---------------------------computed------------
        //下拉选择
        const comboSelect=computed(()=>{
            return (params:any) => {
                if(params && 'videoTypeId'==params.comboId){
                    return dataObj.otherParams.videoTypeData;
                }
            }
        })

        const formatPageInfo=(options:any)=>{

            return options;
        }

        return{
            ...toRefs(dataObj),comboSelect,formatPageInfo
        }
    }
});